import { queryOptions, useQuery } from '@tanstack/react-query';

import { QueryRefetchInterval } from '@cast/shared-types';
import { GetHpaV2MigrationEligibilityResponse } from '@cast/types';

import { apiClient } from '@cast/infrastructure-api';

const WOOP_HPA_V2_MIGRATION_ELIGIBILITY_QUERY_KEY =
  'woop-hpa-v2-migration-eligibility';

export const getHpaV2MigrationEligibilityQueryKey = (clusterId?: string) =>
  clusterId
    ? ([WOOP_HPA_V2_MIGRATION_ELIGIBILITY_QUERY_KEY, clusterId] as const)
    : ([WOOP_HPA_V2_MIGRATION_ELIGIBILITY_QUERY_KEY] as const);

type UseHpaV2MigrationEligibilityQueryArgs = {
  clusterId: string;
  enabled?: boolean;
  refetchInterval?: QueryRefetchInterval<GetHpaV2MigrationEligibilityResponse>;
};

const getHpaV2MigrationEligibilityQueryOptions = ({
  clusterId,
  enabled = true,
  refetchInterval,
}: UseHpaV2MigrationEligibilityQueryArgs) =>
  queryOptions({
    queryKey: getHpaV2MigrationEligibilityQueryKey(clusterId),
    queryFn: async () => {
      const { data } =
        await apiClient.workloadOptimization.getHpaV2MigrationEligibility({
          clusterId,
        });
      return data;
    },
    enabled,
    refetchInterval,
  });

export const useHpaV2MigrationEligibilityQuery = (
  args: UseHpaV2MigrationEligibilityQueryArgs
) => {
  const { isLoading, data, error, refetch } = useQuery(
    getHpaV2MigrationEligibilityQueryOptions(args)
  );

  return { isLoading, data, error, refetch };
};
